<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>逐笔交易管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="交易商名称">
				<el-input v-model="formInline.traderName"></el-input>
			</el-form-item>
			<el-form-item label="债券代码">
				<el-input v-model="formInline.bondCode"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(317)">新增</el-button>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" :row-style='changeRowBgColor'>
			<el-table-column prop="buyDate" label="卖方信息" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.traderSell.traderName}}</div>
					<div>{{scope.row.traderSell.traderContacter}}</div>
					<div>{{scope.row.traderSell.traderTel}}</div>
					<div>{{scope.row.traderSell.traderWX}}</div>
                    <div>{{scope.row.traderSell.traderEmail}}</div>
					<div>{{scope.row.traderSell.traderQQ}}</div>
                </template>
			</el-table-column>
			<el-table-column prop="buyDate" label="买方信息" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.traderBuy.traderName}}</div>
					<div>{{scope.row.traderBuy.traderContacter}}</div>
					<div>{{scope.row.traderBuy.traderTel}}</div>
					<div>{{scope.row.traderBuy.traderWX}}</div>
                    <div>{{scope.row.traderBuy.traderEmail}}</div>
					<div>{{scope.row.traderBuy.traderQQ}}</div>
                </template>
			</el-table-column>
			<el-table-column prop="buyDate" label="债券信息" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.bond.bondCode}}</div>
					<div>{{scope.row.bond.bondName}}</div>
					<div>{{scope.row.bond.rate}}%</div>
                </template>
			</el-table-column>
			<el-table-column prop="buyDate" label="价格/收益" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.price}}元</div>
					<div>{{scope.row.yield}}%</div>
                </template>
			</el-table-column>
			<el-table-column prop="v" label="金额[万]" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="时间" align="center">
				<template slot-scope="scope">
					<div>交易时间：{{scope.row.tradingDate}}</div>
					<div>交割时间：{{scope.row.settlementDate}}</div>
                </template>
			</el-table-column>


			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;"  v-if="jurisdiction.includes(317)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)"  v-if="jurisdiction.includes(318)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form :rules="rules" :model="editForm">
				<el-form-item label="卖方" label-width="120px">
					<el-select v-model="editForm.traderSellId" placeholder="选择交易商" clearable  style="width:200px">
						<el-option :label="item.traderName" :value="item.id" v-for="(item,key) in traderAll"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="买方" label-width="120px">
					<el-select v-model="editForm.traderBuyId" placeholder="选择交易商" clearable style="width:200px">
						<el-option :label="item.traderName" :value="item.id" v-for="(item,key) in traderAll"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="债券" label-width="120px">
					<el-select v-model="editForm.bondCode" placeholder="选择债券" clearable style="width:200px">
						<el-option :label="item.bondName" :value="item.bondCode" v-for="(item,key) in bondsAll"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="金额[万]" label-width="120px">
				<el-input v-model="editForm.v" width="200px"></el-input>
				</el-form-item>
				<el-form-item label="价格[元]" label-width="120px">
				<el-input v-model="editForm.price" width="200px"></el-input>
				</el-form-item>
				<el-form-item label="收益[%]" label-width="120px">
				<el-input v-model="editForm.yield" width="200px"></el-input>
				</el-form-item>
				<el-form-item label="交易日期" label-width="120px">
					<el-date-picker v-model="editForm.tradingDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="结算日期" label-width="120px">
					<el-date-picker v-model="editForm.settlementDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="addEdit" >设置</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addEditBondTick,
		delBondTick,
		getBondTickList,

		getTraderAll,
		getAllBonds
	} from '../../api/basisMG.js'

	export default {
		data() { 
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				editForm: {},
				dialogVisible:false,
				listData: [],
				traderAll:[],
				bondsAll:[],
				directions:[{label:'买',value:'buy'},{label:'卖',value:'sell'}],
			}
		},
		watch: {},

		methods: {
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.direction === 'buy'){
				styleJson = { "color": "red" };} 
				if (row.direction === 'sell'){
				styleJson = { "color": "green" };} 
				return styleJson
			},
			// 获得数据
			getdata() {
				let param = this.formInline
				getBondTickList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			getParamAll(){
				getTraderAll().then(res => {
					if (res.code == '200') {
						this.traderAll = res.data
					}
				})
				getAllBonds().then(res => {
					if (res.code == '200') {
						this.bondsAll = res.data
					}
				})
			},
			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditBondTick(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },
			handledelete(row) {
				let msg = '确认删除' + row.traderName +'?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delBondTick({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getParamAll()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}
	.just-start {
		display: flex;
		justify-content: flex-start;
	}
	.marginT20 {
		margin-top: 20px;
	}
</style>